import type { TFunction } from "i18next"

/** The power line cell's label, for one line or several, with or without their spans. */
export const getPowerLinesLabel = (
  count: number,
  withSpans: boolean,
  t: TFunction,
): string => {
  if (withSpans) {
    return count > 1
      ? t("asset_context.POWERLINES_SPANS_COUNT", { count })
      : t("asset_context.POWERLINE_SPANS")
  }
  return count > 1
    ? t("asset_context.POWERLINES_COUNT", { count })
    : t("entities.POWERLINE")
}
